import { useEffect } from 'react';
import patientProfileImg from '../../assets/Images/patientProfile.png';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextField from '../../components/Form/TextField';
import { resetpasswordById } from '../../actions/authActions';
import { useAlert } from 'react-alert';
import { useSelector, useDispatch } from 'react-redux';
import {HIDE_ALERT_MESSAGE} from '../../constants/Common';
import { formatClinicianName } from '../../utils/clinicianName';



const DoctorProfile = ({doctor}) => {
    
    const dispatch = useDispatch();
    const alert = useAlert();
    const {error, message} = useSelector(state => state.common);

    const validate = Yup.object().shape({
        password: Yup.string()
        .required('Password is Required')
        .min(8, 'password should be 8 characters long')
        .max(20, 'password should be less than 20 characters'),
      });
    

      const submitHandler = (values) => {
        dispatch(resetpasswordById( values.password ,doctor._id))
      }

    useEffect(() => {
        if(message){
            alert.success(message);

            dispatch({
                type: HIDE_ALERT_MESSAGE
            })
        }

        if(error){
            alert.error(error);

            dispatch({
                type: HIDE_ALERT_MESSAGE
            })
        }
    }, [message, error])


  return (
    <div className="row">

    <div className="col-md-8">
    {doctor && <>
            <br />
                    <div className="col-md-12">
                        <div className="row">
                            <img src={patientProfileImg} className="roundedBorderImg" alt="patientProfile" width="80px" height="80px" />
                            <p className="profile-name pl-3">{formatClinicianName(doctor)} <br />
                            <small className="profile-value-text pl-3">{doctor?.email}</small>
                            </p>
                        </div>

                        <hr />
                        <small style={{color: 'dodgerblue'}}>Please type new password.</small>
                        <br/><br/>
                        <Formik initialValues={{
                            password: '',
                            }}
                            validationSchema={validate}
                            onSubmit={values => {
                            submitHandler(values)
                            }}
                            >
                            <div>
                                <Form>
                                <TextField 
                                    label="New Password" 
                                    name="password" 
                                    type="password" 
                                    placeholder="New Password"
                                />
                                 <small>Password must contain atleast one letter and one number</small>
                                
                                <br/><br/>
                                

                                <div className="row-class" style={{justifyContent: 'space-between'}}>
                                    <button className="edit-pill ml-3" type="submit">Reset</button>
                                </div>
                                </Form>
                            </div>
                        </Formik>
                    <br />
            </div>
                            
        </>}
    </div>
    </div>
  )
}

export default DoctorProfile